import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-b border-line bg-ink-800 py-16 md:py-20" aria-labelledby="guarantee-title" data-id="element-85" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-86" data-mp="223y2kzo0jtgf">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400" data-id="element-87" data-mp="22126zhzn1gv5">✅ Zero risk</p>
        <span className="mx-auto mt-6 flex h-16 w-16 items-center justify-center rounded-full border border-emerald-500/40 bg-emerald-500/10" data-id="element-88" data-mp="1x2igr5e0hiwz">
          <ShieldCheckIcon className="h-8 w-8 text-emerald-400" aria-hidden="true" data-id="element-89" data-mp="14gpeqy0ji8b9" />
        </span>
        <h2 id="guarantee-title" className="mt-6 font-display text-3xl font-extrabold uppercase text-white md:text-5xl" data-id="element-90" data-mp="1j5lu7g4xenlw">
          🛡️ 7-Day Money-Back Guarantee
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-91" data-mp="qn7x5irez5nv">
          Open everything. Read everything. Use the material in your next session. Try Baseball 360
          completely risk-free for 7 days. If you're not satisfied for any reason, we'll refund you
          100% — no questions asked. No paperwork. No hassle.
        </p>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-slate-400" data-id="element-92" data-mp="ypb7ninnqbvq">
          No questions asked · Refund rate below 1%
        </p>
      </div>
    </section>;
}